export enum PluginInvocationStatus {
	PLUGIN_FINISHED = 'PLUGIN_FINISHED',
	PLUGIN_ERRORED = 'PLUGIN_ERRORED',
}
